module.exports = __webpack_public_path__ + "static/img/1.0c7f589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/1.png
// module id = Zj6r
// module chunks = 0